import styled from "styled-components";

const LineBreak = styled.div`
  border-top-width: 1px;
  opacity: 0.25;
`

export default LineBreak;